import PropTypes from 'prop-types';
export const ctaPropTypes = {
  /**
   * Heading content
   */
  heading: PropTypes.string,
  /**
   * Description content
   */
  description: PropTypes.string,
  /**
   * Button data - href and label
   */
  button: PropTypes.shape({
    label: PropTypes.string,
    href: PropTypes.string
  }),
  /**
   * Picture data - src for xs and md viewports and alt
   */
  picture: PropTypes.shape({
    xs: {
      src: PropTypes.string.isRequired
    },
    md: {
      src: PropTypes.string.isRequired
    },
    alt: PropTypes.string
  }).isRequired
};